export function getBooleanOptions(trueText, falseText) {
    return [
        { text: trueText, value: true },
        { text: falseText, value: false }
    ];
}
